import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import emailGreyIcon from '../../images/Email Grey.svg';
import idNumberGreyIcon from '../../images/ID Number Grey.svg';
import numberGreyIcon from '../../images/Number Grey.svg';
import './user-card.css';

const UserDetailsCard: FC = () => {
    const formik = useFormikContext<any>();

    return (<><div className="text-1xl text-portal-blue-primary-shade2 font-bold text-ellipsis bound-title"
        title={formik.values.name}>
        {formik.values.name}</div>

        <div className="text-sm mb-1">{formik.values.profileName}</div>
        {formik.values.mobileNumber && <div className="flex flex-row text-xs items-center p-px">
            <img src={numberGreyIcon} alt='' className='w-5 h-4-5 p-px' />
            <p className="ml-2">{formik.values.mobileNumber || 'Not specified'}</p>
        </div>}
        {formik.values.uid && <div className="flex flex-row text-xs items-center p-px">
            <img src={idNumberGreyIcon} alt='' className='w-5 h-4-5 p-px' />
            <p className="ml-2">{formik.values.uid || 'Not specified'}</p>
        </div>}
        {formik.values.email && <div className="flex flex-row text-xs items-center p-px">
            <img src={emailGreyIcon} alt='' className='w-5 h-4-5 p-px' />
            <p className="ml-2">{formik.values.email || 'Not specified'}</p>
        </div>}</>
    );

}

export default UserDetailsCard